import { Flex, spaceMixin, token } from '@zillow/constellation';
import styled from 'styled-components';

export const StyledPlaceholderImage = styled(Flex)`
  background-color: ${token('colors.gray200')};
  width: ${(props) => props.$width}px;
  height: ${(props) => (props.$shouldShowExpiredCaption ? props.$height / 2 : props.$height)}px;
  border-radius: ${(props) => (props.$shouldShowExpiredCaption ? '4px 4px 0 0' : '4px')};
  border: 1px solid
    ${(props) =>
      props.$shouldShowExpiredCaption && props.$isMessageOwner ? token('colors.blue200') : token('colors.gray300')};
`;

export const StyledExpiredCaption = styled(Flex)`
  width: 160px;
  padding: ${spaceMixin('xs')} ${spaceMixin('xs')} 22px ${spaceMixin('xs')};
  border: 1px solid ${(props) => (props.$isMessageOwner ? token('colors.blue200') : token('colors.gray300'))};
  border-top: none;
  border-radius: 0 0 4px 4px;
  margin-top: -4px;
`;
